var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"dashboard"}},[_c('v-content',[_c('v-container',{staticStyle:{"padding":"0px"},attrs:{"fluid":"","full-height":""}},[_c('router-view',{directives:[{name:"transition",rawName:"v-transition"}]})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-621bebdb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/dashboard.vue
// module id = null
// module chunks = 